import { InlineEditorEditButton,InlineEditorLogic, isReadonlyMode, useInlineEditor } from '@tableau/vizportalclient-common-components';
import React from 'react';
import _ from 'underscore';

import { SpaceHeaderTestIds } from '~src/spacesPlatform/components/header/SpaceHeader';
import { SpaceHeaderStyles } from '~src/spacesPlatform/components/header/SpaceHeaderStyles';
import { ToasterService, ToastType } from '~src/ts/services/ToasterService';

import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { LensesTAGHandler } from '../api/LensTAG';
import { NAME_MAX_LENGTH } from '../constants/lensconstants';
import { LensInlineNameEditorEditMode } from './LensNameEditMode';
import { LensSpaceHeaderProps } from './LensSpaceHeader';

export interface EditableLensNameComponentProps extends LensSpaceHeaderProps {
  readonly onEditChange: (isEditing: boolean) => void;
  readonly canEdit: boolean;
  readonly hasEditPermissions: boolean;
}

export function EditableLensName(props: EditableLensNameComponentProps) {
  const [errorMessage, setErrorMessage] = React.useState(undefined);
  const [name, setName] = React.useState(props.item.name);

  const clearErrorMessage = (): void => {
    setErrorMessage(undefined);
  };

  const updateName = async (name: string): Promise<void> => {
    try {
      await LensesTAGHandler.editName(props.item.id, name);
      ToasterService.instance.pop({ type: ToastType.Success, text: Messages.lensName_Toast_Success()});
      props.reloadSpace();
      props.onEditChange && props.onEditChange(false);
      setName(name);
    } catch (e) {
      ToasterService.instance.pop({ type: ToastType.Error, text: Messages.lensName_Toast_Error()});
      props.reloadSpace();
      props.onEditChange && props.onEditChange(false);
    }
  };

  const canEdit = props.canEdit;

  const logic: InlineEditorLogic<string> = useInlineEditor<string>({
    editorStateWhenEnteringEditMode: name,
    canEdit: canEdit,
    onSave: updateName,
    onCancel: () => {
      props.onEditChange && props.onEditChange(false);
      setErrorMessage(undefined);
    },
    canSaveFn: isValidName,
  });

  const editableStyling: string = canEdit ? SpaceHeaderStyles.HeaderEditableInlineElement : '';

  if (isReadonlyMode(logic)) {
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    return <h1
      data-tb-test-id={SpaceHeaderTestIds.name}
      className={`${SpaceHeaderStyles.EditableTitleReadonly} ${editableStyling}`}
      onClick={() => {
        canEdit && logic.enterEditMode();
        props.onEditChange && props.onEditChange(true);
      }}
    >
      {name}
      {props.hasEditPermissions &&
        <span style={{ paddingLeft: CommonStyles.Sizes.SmallSpace }}>
          <InlineEditorEditButton {...logic} editButtonLabel={Messages.editName()} />
        </span>
      }
    </h1>;
  } else {
    return <LensInlineNameEditorEditMode editLogic={logic} errorMessage={errorMessage} clearErrorMessage={clearErrorMessage}/>;
  }
}

export function isValidName(name: string): boolean {
  return (!_.isUndefined(name) &&
    name.trim().length > 0 &&
    name.length <= NAME_MAX_LENGTH);
}
